import Vue from "vue";
import ElementUI from "element-ui";
import Theme from "@/theme/desktop"
import "@/theme/desktop/styles/index.scss";
import "./tailwind.css";
import "./icon/index.css"

Vue.use(ElementUI, {
    size: "small"
});
Vue.use(Theme)



export default ElementUI;
